import React from 'react'
import {motion} from 'framer-motion'

import {Spinner} from '@daedalus/atlas/Spinner'

import {
  CarouselLoadingItem,
  LeftPanel,
  RightPanel,
  ThumbnailLoadingItem,
  ThumbnailWrapper,
  Wrapper
} from './styles'

export const LightboxGalleryDesktopLoading = () => {
  const thumbnails = new Array(10).fill(1)
  return (
    <Wrapper>
      <LeftPanel className="isLoadingState">
        <motion.div
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          transition={{duration: 0.2}}
          className="motion-element"
        >
          <CarouselLoadingItem>
            <Spinner colorPath="background.neutral.c300" />
          </CarouselLoadingItem>
        </motion.div>
      </LeftPanel>
      <RightPanel>
        <motion.div
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          transition={{duration: 0.2}}
        >
          <ThumbnailWrapper>
            {thumbnails.map((key, index) => (
              <ThumbnailLoadingItem
                key={`ThumbnailLoadingItem-${key}-${index}`}
              >
                <Spinner colorPath="background.neutral.c300" />
              </ThumbnailLoadingItem>
            ))}
          </ThumbnailWrapper>
        </motion.div>
      </RightPanel>
    </Wrapper>
  )
}
